import { render, staticRenderFns } from "./WyfStories.vue?vue&type=template&id=1d98098f"
import script from "./WyfStories.vue?vue&type=script&lang=ts"
export * from "./WyfStories.vue?vue&type=script&lang=ts"
import style0 from "./WyfStories.vue?vue&type=style&index=0&id=1d98098f&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default,AppBtn: require('/builds/project/wyffest/frontend/components/app/AppBtn.vue').default,WyfStoriesDialog: require('/builds/project/wyffest/frontend/components/wyf/stories/WyfStoriesDialog.vue').default})
